import dayjs from '~/src/common/services/Date';
import { Product } from '~/src/typings/products/types';

export const getPromoDateConditions = (promo: NonNullable<Product['promo']>) => {
  if (!promo.active || promo.conditions?.endDate == null) return null;

  return {
    startDate: dayjs(promo?.conditions?.startDate).format('DD/MM'),
    endDate: dayjs(promo?.conditions?.endDate).format('DD/MM'),
  };
};
